import { routeConfig } from '../config/route.config';

export const url = (uri: string) => routeConfig.baseUrl + uri;